import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import AdvancedRecordTable from '../../components/Tables/advancedRecord/AdvancedRecordTable';

import { useReceivableTable } from '../../modules/receivable/table/hooks/useReceivableTable';
import { receivableTableColumns } from '../../modules/receivable/table/config/receivableTableColumns';
import { getReceivableFilters } from '../../modules/receivable/table/config/receivableTableFilters';
import { getReceivableTableActions } from '../../modules/receivable/types/receivableTableActions';

import { useCustomer } from '../../hooks/useCustomer';
import { useReceivableDetail } from '../../modules/receivable/detail/hooks/useReceivableDetail';
import { useSale } from '../../hooks/sale/useSale';

import ReceivableDetailModal from '../../modules/receivable/detail/components/ReceivableDetailModal';
import SaleViewModal from '../Sale/history/SaleViewModal';

import { ReceivableFilter } from '../../modules/receivable/types/receivableFilter.types';
import { getUpcomingDateRange } from '../../utils/date/dateRange';

const UpcomingDueCxcPage = () => {
  const navigate = useNavigate();

  const { saleToViewLoaded, handleCloseViewModal } = useSale();

  const { list, paginator, size, fetchReceivables, changeSize } =
    useReceivableTable();

  const { isModalOpen, handleOpenDetailModal, handleCloseDetailModal } =
    useReceivableDetail();

  const { handlerGetCustomersForDropdown, customersDropdown } = useCustomer();

  /**
   * 🔥 SOLO próximos a vencer
   */

  const baseFilter: ReceivableFilter = {
    statuses: ['PENDING', 'PARTIAL'],
    ...getUpcomingDateRange(7),
  };

  const [filters, setFilters] = useState<ReceivableFilter>(baseFilter);

  /**
   * 🔍 filtros
   */
  const handleFilterChange = (newFilters: ReceivableFilter) => {
    const merged = {
      ...baseFilter,
      ...newFilters,
    };

    setFilters(merged);
    fetchReceivables(merged, 0);
  };

  /**
   * 🔄 reset
   */
  const handleResetFilters = () => {
    setFilters(baseFilter);
    fetchReceivables(baseFilter, 0);
  };

  /**
   * 📄 paginación
   */
  const handlePageChange = (page: number) => {
    fetchReceivables(filters, page);
  };

  const handlePageSizeChange = (newSize: number) => {
    changeSize(newSize, filters);
  };

  useEffect(() => {
    fetchReceivables(baseFilter);
    handlerGetCustomersForDropdown();
  }, []);

  const filterFields = getReceivableFilters(customersDropdown);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <AdvancedRecordTable
        columns={receivableTableColumns}
        data={list}
        paginator={paginator}
        pageSize={size}
        filtersConfig={filterFields}
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        url="/upcoming-due-cxc"
        noDataMessage="No hay cuentas próximas a vencer."
        getActions={(row) =>
          getReceivableTableActions({
            row,
            handlers: {
              onView: (id) => handleOpenDetailModal(id),

              onPay: (id) => navigate(`/finance/cxc/register-payment/${id}`),

              onHistory: (id) => navigate(`/finance/cxc/payment-history/${id}`),
            },
          })
        }
      />

      <ReceivableDetailModal
        isOpen={isModalOpen}
        onClose={handleCloseDetailModal}
      />

      <SaleViewModal isOpen={saleToViewLoaded} onClose={handleCloseViewModal} />
    </DefaultLayout>
  );
};

export default UpcomingDueCxcPage;
